import {Component} from '@angular/core';
import {ToastService} from './toast.service';

@Component({
  selector: 'app-toast-container',
  template: `
    <div class="toast-stack" aria-live="polite">
      <div *ngFor="let toast of toastService.toasts$ | async" class="app-toast" [ngClass]="'toast-' + toast.kind"
           role="status" (click)="toastService.dismiss(toast.id)">
        <i class="bi" [ngClass]="{
          'bi-check-circle-fill': toast.kind === 'success',
          'bi-exclamation-circle-fill': toast.kind === 'error',
          'bi-info-circle-fill': toast.kind === 'info'}"></i>
        <span>{{ toast.text }}</span>
      </div>
    </div>
  `,
  styles: [`
    .toast-stack {
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      bottom: calc(var(--tabbar-h) + var(--safe-bottom) + 0.75rem);
      z-index: 2000;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      width: min(92vw, 420px);
      pointer-events: none;
    }
    @media (min-width: 768px) {
      .toast-stack { bottom: 1.5rem; }
    }
    .app-toast {
      display: flex;
      align-items: center;
      gap: 0.6rem;
      padding: 0.7rem 0.95rem;
      border-radius: 12px;
      background: #1f2937;
      color: #fff;
      box-shadow: 0 8px 24px rgba(17, 24, 39, 0.25);
      font-size: 0.92rem;
      pointer-events: auto;
      animation: toast-in 0.18s ease-out;
    }
    .toast-success i { color: #4ade80; }
    .toast-error i { color: #f87171; }
    .toast-info i { color: #93c5fd; }
    @keyframes toast-in {
      from { opacity: 0; transform: translateY(8px); }
      to { opacity: 1; transform: none; }
    }
  `],
  standalone: false
})
export class ToastContainerComponent {
  constructor(public toastService: ToastService) {
  }
}
